import type { Map } from 'immutable';

import { LinearGraphReducerState } from 'features/dashboard/redux/createLinearChartReducer';
import { ChartViewMode } from 'features/dashboard/ts/ChartViewMode';
import { LinearChartItem } from 'features/dashboard/ts/LinearCharItem';
import { RadialChartItem } from 'features/dashboard/ts/RadialChartItem';
import { SummaryReducerGraphState } from 'features/dashboard/redux/reducers/summaryGraph';

export const pickLinearGraph = (state: LinearGraphReducerState): Map<number, LinearChartItem[]> => {
  switch (state.mode) {
    case ChartViewMode.Daily:
      return state.dailyGraph;
    case ChartViewMode.Weekly:
      return state.weeklyGraph;
    case ChartViewMode.Monthly:
      return state.monthlyGraph;
  }
};
export const pickRadialChart = (state: SummaryReducerGraphState): Map<number, RadialChartItem[]> => {
  switch (state.mode) {
    case ChartViewMode.Daily:
      return state.dailyGraph;
    case ChartViewMode.Weekly:
      return state.weeklyGraph;
    case ChartViewMode.Monthly:
      return state.monthlyGraph;
  }
};
